// extracted by mini-css-extract-plugin
export default {"mCard":"CB-z","image":"DB-z","imageNoBackground":"EB-z","imageHasCategory":"FB-z","fullWidth":"GB-z"};